<template>
  <!-- begin:: Header -->
  <div
    id="kt_header"
    ref="kt_header"
    class="header"
    v-bind:class="headerClasses"
  >
    <div
      class="container-fluid d-flex align-items-right justify-content-between"
    >
      <!-- begin:: Header Menu -->
      <div
        class="header-menu-wrapper header-menu-wrapper-left col p-0 align-self-center"
        ref="kt_header_menu_wrapper"
      >
        <div class="row align-items-center">
          <div class="col-auto">
            <h6
              class="mb-0 font-weight-bolder align-items-center"
              v-blur-sensitive
              v-html="currentUserPersonalInfo.cliente"
            ></h6>
            <p
              class="mb-0"
              v-if="currentUserPersonalInfo.conta"
              v-b-tooltip.html="
                isPresentationMode
                  ? 'Código da conta oculto no modo apresentação'
                  : currentUserPersonalInfo.conta_id
              "
            >
              <span class="font-weight-bolder">Conta:</span>
              <span v-blur-sensitive>
                {{ currentUserPersonalInfo.conta }}
              </span>
            </p>
            <p class="mb-0" v-if="currentUserPersonalInfo.emailCliente">
              <span class="font-weight-bolder">Email:</span>
              <span v-blur-sensitive>
                {{ currentUserPersonalInfo.emailCliente }}
              </span>
            </p>
          </div>

          <div
            class="col-auto"
            v-if="
              (checkSuperAdmin || isAccountAdmin) && contasParaTroca.length > 0
            "
          >
            <div class="d-flex">
              <button
                @click="trocarUsuarioOuConta"
                class="btn btn-wellon-branco btn-sm"
              >
                <i class="fas fa-arrow-right-arrow-left"></i>
                Trocar Conta
              </button>
              <button
                v-if="hasPermission('modo-apresentacao')"
                @click="togglePresentation"
                class="btn btn-wellon-branco btn-sm ml-3"
                :class="{ active: isPresentationMode }"
                title="Modo Apresentação"
              >
                <i
                  :class="
                    isPresentationMode ? 'fas fa-eye-slash' : 'fas fa-eye'
                  "
                ></i>
                {{ isPresentationMode ? "Desativar" : "Ativar" }} Apresentação
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- end:: Header Menu -->

      <KTTopbar></KTTopbar>
    </div>

    <b-modal
      ref="mdlTrocarUsuarioOuConta"
      title="Trocar Conta"
      @hidden="limpar"
      ignore-enforce-focus-selector=".swal2-container"
      v-if="(checkSuperAdmin || isAccountAdmin) && contasParaTroca.length > 0"
      hide-footer
      size="lg"
      scrollable
      content-class="trocar-conta-modal-content"
      header-class="trocar-conta-modal-header border-0"
      body-class="trocar-conta-modal-body"
    >
      <div>
        <button
          v-if="checkSuperAdmin && hasAccount"
          type="button"
          class="trocar-conta-admin-card"
          @click="trocarParaSuperAdmin"
        >
          <span class="trocar-conta-admin-card__icone">
            <i class="fas fa-star"></i>
          </span>
          <span class="trocar-conta-admin-card__textos">
            <span class="trocar-conta-admin-card__titulo">
              Trocar para Administrador do Sistema
            </span>
            <span class="trocar-conta-admin-card__subtitulo">
              Acesse o painel com visão completa da plataforma.
            </span>
          </span>
        </button>

        <b-form-input
          v-model="filtroContas"
          placeholder="Buscar por nome, sigla, código ou documento"
          @input="debounce"
          @keyup.enter="changeSelected"
          @keyup.up="handleKeyUpDown"
          @keyup.down="handleKeyUpDown"
          :autofocus="true"
          class="trocar-conta-busca mb-3"
        ></b-form-input>

        <div class="trocar-conta-chips">
          <button
            v-for="chip in chipsFiltro"
            :key="chip.valor"
            type="button"
            class="trocar-conta-chip"
            :class="{ 'trocar-conta-chip--ativo': filtroStatus === chip.valor }"
            @click="filtroStatus = chip.valor"
          >
            {{ chip.texto }}
          </button>
        </div>

        <div ref="lista" class="trocar-conta-lista">
          <template v-for="item in itensLista">
            <div
              v-if="item.tipo === 'cabecalho'"
              :key="item.chave"
              class="trocar-conta-secao-titulo"
            >
              <span>
                <i
                  class="fas fa-circle trocar-conta-dot"
                  :class="`trocar-conta-dot--${item.corDot}`"
                ></i>
                {{ item.texto }}
              </span>
              <span class="trocar-conta-secao-contador">
                {{ item.contador }} conta{{ item.contador === 1 ? "" : "s" }}
              </span>
            </div>

            <div v-else :key="item.chave" class="trocar-conta-card">
              <div class="trocar-conta-card__principal">
                <button
                  type="button"
                  class="trocar-conta-card__info linha-navegavel"
                  :data-conta-id="item.grupo.principal.id"
                  @click="trocarConta(item.grupo.principal.id)"
                  @keydown="handleKeyUpDown"
                >
                  <span class="trocar-conta-avatar" v-blur-sensitive>
                    {{ avatarTexto(item.grupo.principal) }}
                  </span>

                  <span class="trocar-conta-card__textos">
                    <span class="trocar-conta-card__linha1">
                      <span class="trocar-conta-card__nome" v-blur-sensitive>
                        {{ nomeExibicao(item.grupo.principal) }}
                      </span>
                      <span
                        v-if="!item.grupo.principal.contaPrincipalId"
                        class="trocar-conta-badge trocar-conta-badge--principal"
                      >
                        Conta principal
                      </span>
                      <span
                        class="trocar-conta-badge"
                        :class="`trocar-conta-badge--${
                          statusInfo(item.grupo.principal.status).classe
                        }`"
                      >
                        {{ statusInfo(item.grupo.principal.status).texto }}
                      </span>
                    </span>
                    <span
                      class="trocar-conta-card__linha2 text-muted"
                      v-blur-sensitive
                    >
                      Código {{ item.grupo.principal.id }}
                      <template v-if="documentoExibicao(item.grupo.principal)">
                        · {{ documentoExibicao(item.grupo.principal) }}
                      </template>
                    </span>
                  </span>
                </button>

                <button
                  v-if="
                    !ocultarSubcontas && item.grupo.subcontasVisiveis.length > 0
                  "
                  type="button"
                  class="trocar-conta-card__toggle"
                  @click="alternarExpandirPrincipal(item.grupo.principal.id)"
                  :title="
                    grupoEstaExpandido(item.grupo)
                      ? 'Recolher subcontas'
                      : 'Expandir subcontas'
                  "
                >
                  <i
                    :class="
                      grupoEstaExpandido(item.grupo)
                        ? 'fas fa-chevron-up'
                        : 'fas fa-chevron-down'
                    "
                  ></i>
                </button>
              </div>

              <div
                v-if="
                  !ocultarSubcontas &&
                  grupoEstaExpandido(item.grupo) &&
                  item.grupo.subcontasVisiveis.length > 0
                "
                class="trocar-conta-card__subcontas"
              >
                <div class="trocar-conta-card__subcontas-cabecalho">
                  <span
                    >Subcontas ({{ item.grupo.subcontasVisiveis.length }})</span
                  >
                </div>

                <button
                  v-for="sub in subcontasParaExibir(item.grupo)"
                  :key="sub.id"
                  type="button"
                  class="trocar-conta-subconta linha-navegavel"
                  :data-conta-id="sub.id"
                  @click="trocarConta(sub.id)"
                  @keydown="handleKeyUpDown"
                >
                  <span class="trocar-conta-subconta__textos">
                    <span class="trocar-conta-subconta__login" v-blur-sensitive>
                      {{ sub.login }} ({{ sub.id }})
                    </span>
                    <span
                      class="trocar-conta-subconta__nome text-muted"
                      v-blur-sensitive
                    >
                      {{ nomeExibicao(sub) }}
                    </span>
                  </span>
                  <span
                    class="trocar-conta-badge"
                    :class="`trocar-conta-badge--${
                      statusInfo(sub.status).classe
                    }`"
                  >
                    {{ statusInfo(sub.status).texto }}
                  </span>
                </button>

                <button
                  v-if="
                    !termoBusca.trim() &&
                    item.grupo.subcontasVisiveis.length >
                      limiteSubcontasPadrao &&
                    !subcontasExpandidas.includes(item.grupo.principal.id)
                  "
                  type="button"
                  class="trocar-conta-ver-todas"
                  @click="expandirTodasSubcontas(item.grupo.principal.id)"
                >
                  Ver todas as
                  {{ item.grupo.subcontasVisiveis.length }} subcontas
                </button>
              </div>
            </div>
          </template>

          <p v-if="itensLista.length === 0" class="text-muted text-center my-4">
            Nenhuma conta encontrada.
          </p>
        </div>
      </div>
    </b-modal>
  </div>
  <!-- end:: Header -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import KTTopbar from "@/view/layout/header/Topbar.vue";
import KTLayoutHeader from "@/assets/js/layout/base/header.js";
import ApiService from "../../../core/services/api.service";
import Utils from "@/core/utils/Utils";
import Swal from "sweetalert2";

const STATUS_INFO = {
  A: { texto: "Ativa", classe: "ativa" },
  I: { texto: "Inativa", classe: "inativa" },
  B: { texto: "Bloqueada", classe: "bloqueada" },
  S: { texto: "Suspensa", classe: "suspensa" }
};

export default {
  name: "KTHeader",
  components: {
    KTTopbar
  },
  data() {
    return {
      contas: [],
      idContaSelecionada: null,
      filtroContas: "",
      termoBusca: "",
      filtroStatus: "todas",
      debounceTimeout: null,
      limiteSubcontasPadrao: 3,
      principaisExpandidos: [],
      subcontasExpandidas: [],
      chipsFiltro: [
        { valor: "todas", texto: "Todas" },
        { valor: "ativas", texto: "Ativas" },
        { valor: "inativas", texto: "Inativas" },
        { valor: "principais", texto: "Principais" }
      ]
    };
  },
  mounted() {
    // Init Desktop & Mobile Headers
    KTLayoutHeader.init("kt_header", "kt_header_mobile");
  },
  computed: {
    ...mapGetters([
      "getClasses",
      "currentUserPersonalInfo",
      "hasAccount",
      "isAccountAdmin",
      "contasParaTroca",
      "checkSuperAdmin",
      "isAdmin",
      "isPresentationMode",
      "hasPermission"
    ]),

    /**
     * Get extra classes for header based on the options
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    ocultarSubcontas() {
      return this.filtroStatus === "principais";
    },

    // Agrupa a lista plana de contas em contas principais + suas subcontas,
    // já aplicando o termo de busca (nome, login, sigla, id ou documento).
    // Uma subconta cujo pai não esteja na lista (ex.: usuário vinculado só à
    // subconta) é tratada como um grupo "principal" próprio, sem cair fora da tela.
    gruposContas() {
      const contasPorId = new Map(
        this.contas.map((conta) => [conta.id, conta])
      );
      const termo = this.termoBusca.trim().toLowerCase();
      const termoDigitos = termo.replace(/\D/g, "");

      const correspondeTermo = (conta) => {
        if (!termo) {
          return true;
        }

        const documentoLimpo = Utils.limparDocumento(
          conta.documento
        ).toLowerCase();

        return (
          this.nomeExibicao(conta).toLowerCase().includes(termo) ||
          (conta.login || "").toLowerCase().includes(termo) ||
          (conta.sigla || "").toLowerCase().includes(termo) ||
          String(conta.id).includes(termo) ||
          (termoDigitos.length > 0 && documentoLimpo.includes(termoDigitos))
        );
      };

      const subcontasPorPrincipal = new Map();
      const principais = [];

      this.contas.forEach((conta) => {
        const temPrincipalNaLista =
          conta.contaPrincipalId && contasPorId.has(conta.contaPrincipalId);

        if (temPrincipalNaLista) {
          if (!subcontasPorPrincipal.has(conta.contaPrincipalId)) {
            subcontasPorPrincipal.set(conta.contaPrincipalId, []);
          }
          subcontasPorPrincipal.get(conta.contaPrincipalId).push(conta);
        } else {
          principais.push(conta);
        }
      });

      return principais
        .map((principal) => {
          const subcontas = (subcontasPorPrincipal.get(principal.id) || [])
            .slice()
            .sort((a, b) =>
              this.nomeExibicao(a).localeCompare(this.nomeExibicao(b))
            );

          const subcontasVisiveis = termo
            ? subcontas.filter(correspondeTermo)
            : subcontas;

          return {
            principal,
            subcontasVisiveis,
            corresponde:
              correspondeTermo(principal) || subcontasVisiveis.length > 0
          };
        })
        .filter((grupo) => grupo.corresponde)
        .sort((a, b) => {
          const pesoA = a.principal.status === "A" ? 0 : 1;
          const pesoB = b.principal.status === "A" ? 0 : 1;

          if (pesoA !== pesoB) {
            return pesoA - pesoB;
          }

          return this.nomeExibicao(a.principal).localeCompare(
            this.nomeExibicao(b.principal)
          );
        });
    },

    gruposContasAtivas() {
      return this.gruposContas.filter(
        (grupo) => grupo.principal.status === "A"
      );
    },

    gruposContasInativas() {
      return this.gruposContas.filter(
        (grupo) => grupo.principal.status !== "A"
      );
    },

    exibirSecaoAtivas() {
      return this.filtroStatus !== "inativas";
    },

    exibirSecaoInativas() {
      return this.filtroStatus !== "ativas";
    },

    // Lista única (cabeçalhos de seção + cards) na ordem final de exibição,
    // para não duplicar o markup do card entre as seções ativas/inativas.
    itensLista() {
      const itens = [];
      const ativas = this.gruposContasAtivas;
      const inativas = this.gruposContasInativas;

      if (this.exibirSecaoAtivas && ativas.length > 0) {
        itens.push({
          tipo: "cabecalho",
          chave: "cabecalho-ativas",
          texto: "Contas ativas",
          contador: ativas.length,
          corDot: "ativa"
        });
        ativas.forEach((grupo) =>
          itens.push({
            tipo: "grupo",
            chave: `grupo-${grupo.principal.id}`,
            grupo
          })
        );
      }

      if (this.exibirSecaoInativas && inativas.length > 0) {
        itens.push({
          tipo: "cabecalho",
          chave: "cabecalho-inativas",
          texto: "Contas inativas",
          contador: inativas.length,
          corDot: "inativa"
        });
        inativas.forEach((grupo) =>
          itens.push({
            tipo: "grupo",
            chave: `grupo-${grupo.principal.id}`,
            grupo
          })
        );
      }

      return itens;
    }
  },

  methods: {
    ...mapActions(["togglePresentationMode"]),

    togglePresentation() {
      const title = `Você deseja ${
        this.isPresentationMode ? "desativar" : "ativar"
      } o modo de apresentação?`;
      const text = this.isPresentationMode
        ? "Essa ação irá revelar informações sensíveis na tela."
        : "Essa ação irá ocultar informações sensíveis na tela para apresentações.";
      Swal.fire({
        title: title,
        text: text,
        icon: "warning",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        showCancelButton: true,
        buttonsStyling: true
      }).then((result) => {
        if (result.value) {
          this.togglePresentationMode();
        }
      });
    },

    trocarUsuarioOuConta() {
      this.contas = [...this.contasParaTroca];
      this.$refs["mdlTrocarUsuarioOuConta"].show();
    },

    nomeExibicao(conta) {
      return conta.nome || conta.cliNome || conta.login || "";
    },

    avatarTexto(conta) {
      if (conta.sigla && conta.sigla.trim()) {
        return conta.sigla.trim().toUpperCase().slice(0, 3);
      }

      const nome = this.nomeExibicao(conta).trim();
      if (!nome) {
        return "?";
      }

      const partes = nome.split(/\s+/);
      if (partes.length === 1) {
        return partes[0].slice(0, 2).toUpperCase();
      }

      return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
    },

    documentoExibicao(conta) {
      const limpo = Utils.limparDocumento(conta.documento);

      if (!limpo) {
        return "";
      }

      if (limpo.length === 11) {
        return `CPF: ${Utils.formatarDocumento(limpo)}`;
      }

      if (limpo.length === 14) {
        return `CNPJ: ${Utils.formatarDocumento(limpo)}`;
      }

      return `Documento: ${conta.documento}`;
    },

    statusInfo(status) {
      return STATUS_INFO[status] || STATUS_INFO.B;
    },

    subcontasParaExibir(grupo) {
      if (this.termoBusca.trim()) {
        return grupo.subcontasVisiveis;
      }

      if (this.subcontasExpandidas.includes(grupo.principal.id)) {
        return grupo.subcontasVisiveis;
      }

      return grupo.subcontasVisiveis.slice(0, this.limiteSubcontasPadrao);
    },

    expandirTodasSubcontas(idPrincipal) {
      if (!this.subcontasExpandidas.includes(idPrincipal)) {
        this.subcontasExpandidas.push(idPrincipal);
      }
    },

    alternarExpandirPrincipal(idPrincipal) {
      const indice = this.principaisExpandidos.indexOf(idPrincipal);
      if (indice === -1) {
        this.principaisExpandidos.push(idPrincipal);
      } else {
        this.principaisExpandidos.splice(indice, 1);
      }
    },

    grupoEstaExpandido(grupo) {
      if (this.termoBusca.trim() && grupo.subcontasVisiveis.length > 0) {
        return true;
      }

      return this.principaisExpandidos.includes(grupo.principal.id);
    },

    debounce(filtro) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.termoBusca = filtro;
        this.removeSelected();
      }, 300);
    },

    limpar() {
      this.idContaSelecionada = null;
      this.contas = [];
      this.filtroContas = "";
      this.termoBusca = "";
      this.filtroStatus = "todas";
      this.principaisExpandidos = [];
      this.subcontasExpandidas = [];
    },

    trocarConta(conta) {
      Swal.fire({
        title: "Deseja realmente trocar para a conta selecionada?",
        showCancelButton: true,
        confirmButtonText: "Trocar",
        cancelButtonText: "Cancelar",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-success"
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          ApiService.post("/usuario/trocar-conta", {
            contaId: conta
          }).then(() => {
            localStorage.removeItem(
              "filtrosCampanha-" + this.currentUserPersonalInfo.login
            );
            window.location.href = "/";
          });
        }
      });
    },

    trocarParaSuperAdmin() {
      Swal.fire({
        title:
          "Deseja realmente trocar o usuário para Administrador do Sistema?",
        showCancelButton: true,
        confirmButtonText: "Trocar",
        cancelButtonText: "Cancelar",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-info"
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          ApiService.get("/usuario/trocar-para-super-admin").then(() => {
            window.location.href = "/";
          });
        }
      });
    },

    obterIdContaSelecionada(obj) {
      this.idContaSelecionada = obj ? obj.id : null;
    },

    obterLinhasNavegaveis() {
      return Array.from(this.$refs.lista.querySelectorAll(".linha-navegavel"));
    },

    focusFirstItem() {
      const linhas = this.obterLinhasNavegaveis();
      if (linhas[0]) {
        linhas[0].classList.add("selecionado");
      }
    },

    handleKeyUpDown(event) {
      const linhas = this.obterLinhasNavegaveis();
      const atual = linhas.findIndex((el) =>
        el.classList.contains("selecionado")
      );

      if (atual === -1) {
        this.focusFirstItem();
        return;
      }

      if (event.key === "ArrowDown" && atual < linhas.length - 1) {
        linhas[atual].classList.remove("selecionado");
        linhas[atual + 1].classList.add("selecionado");
      } else if (event.key === "ArrowUp" && atual > 0) {
        linhas[atual].classList.remove("selecionado");
        linhas[atual - 1].classList.add("selecionado");
      }
    },

    changeSelected() {
      const ativa = this.obterLinhasNavegaveis().find((el) =>
        el.classList.contains("selecionado")
      );

      if (ativa) {
        this.trocarConta(ativa.getAttribute("data-conta-id"));
      }
    },

    removeSelected() {
      const ativa = this.obterLinhasNavegaveis().find((el) =>
        el.classList.contains("selecionado")
      );
      ativa?.classList.remove("selecionado");
    }
  }
};
</script>

<style lang="scss">
$trocar-conta-purple: #472282;

.trocar-conta-modal-content {
  border: 1px solid #eeecf3;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(31, 20, 60, 0.15);
  overflow: hidden;
}

.trocar-conta-modal-header {
  padding: 1.5rem 1.75rem 0.75rem;

  .modal-title {
    font-weight: 700;
    color: #2b2640;
  }

  .close {
    color: #2b2640;
    text-shadow: none;
    outline: none;

    &:hover {
      color: $trocar-conta-purple;
    }
  }
}

.trocar-conta-modal-body {
  padding: 0.5rem 1.75rem 1.75rem;
}

.trocar-conta-admin-card {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  width: 100%;
  padding: 0.9rem 1.1rem;
  margin-bottom: 1.25rem;
  border: 1px solid #d9cdf0;
  border-radius: 12px;
  background: #f7f4fc;
  text-align: left;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #ece8f2;
    border-color: $trocar-conta-purple;
  }

  &__icone {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    flex: 0 0 auto;
    background: linear-gradient(135deg, #ede8f7 0%, #d9cdf0 100%);
    color: $trocar-conta-purple;
  }

  &__textos {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &__titulo {
    font-weight: 700;
    color: #2b2640;
  }

  &__subtitulo {
    font-size: 0.82rem;
    color: #837f95;
  }
}

.trocar-conta-busca {
  height: calc(1.5em + 1.3rem + 2px);
  padding: 0.65rem 1rem;
  border-radius: 8px;
  border: 1px solid #e2e0ea;

  &:focus {
    border-color: $trocar-conta-purple;
    box-shadow: 0 0 0 0.1rem rgba(71, 34, 130, 0.15);
  }
}

.trocar-conta-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
}

.trocar-conta-chip {
  padding: 0.4rem 0.9rem;
  border-radius: 999px;
  border: 1px solid #e2e0ea;
  background: #fff;
  color: #6a6579;
  font-size: 0.82rem;
  font-weight: 600;
  transition: background-color 0.15s ease, color 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    border-color: $trocar-conta-purple;
    color: $trocar-conta-purple;
  }

  &--ativo {
    background: $trocar-conta-purple;
    border-color: $trocar-conta-purple;
    color: #fff;
  }
}

.trocar-conta-secao-titulo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  color: #2b2640;
  margin: 1.25rem 0 0.6rem;
  font-size: 0.9rem;

  &:first-child {
    margin-top: 0;
  }
}

.trocar-conta-secao-contador {
  font-size: 0.78rem;
  font-weight: 600;
  color: #837f95;
  background: #f4f2f9;
  border-radius: 999px;
  padding: 0.15rem 0.6rem;
}

.trocar-conta-dot {
  font-size: 0.5rem;
  margin-right: 0.35rem;

  &--ativa {
    color: #0e8058;
  }

  &--inativa {
    color: #b42335;
  }
}

.trocar-conta-card {
  border: 1px solid #eeecf3;
  border-radius: 12px;
  margin-bottom: 0.75rem;
  overflow: hidden;
}

.trocar-conta-card__principal {
  display: flex;
  align-items: stretch;
}

.trocar-conta-card__info {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  flex: 1 1 auto;
  min-width: 0;
  padding: 0.85rem 1rem;
  text-align: left;
  background: #fff;
  transition: background-color 0.15s ease;

  &:hover,
  &.selecionado {
    background: #f7f4fc;
  }
}

.trocar-conta-avatar {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: $trocar-conta-purple;
  background: linear-gradient(135deg, #ede8f7 0%, #d9cdf0 100%);
  border: 2px solid #e2d8f5;
}

.trocar-conta-card__textos {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 0.2rem;
}

.trocar-conta-card__linha1 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.trocar-conta-card__nome {
  font-weight: 700;
  color: #2b2640;
}

.trocar-conta-card__linha2 {
  font-size: 0.82rem;
}

.trocar-conta-card__toggle {
  flex: 0 0 auto;
  width: 44px;
  border: 0;
  border-left: 1px solid #eeecf3;
  background: #fff;
  color: #837f95;

  &:hover {
    background: #f7f4fc;
    color: $trocar-conta-purple;
  }
}

.trocar-conta-card__subcontas {
  border-top: 1px solid #eeecf3;
  background: #fafafc;
  padding: 0.6rem 1rem 0.75rem 3.75rem;
}

.trocar-conta-card__subcontas-cabecalho {
  font-size: 0.78rem;
  font-weight: 700;
  color: #837f95;
  text-transform: uppercase;
  margin-bottom: 0.4rem;
}

.trocar-conta-subconta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  padding: 0.5rem 0.6rem;
  border-radius: 8px;
  background: transparent;
  text-align: left;
  border-top: 1px solid #eeecf3;

  &:first-of-type {
    border-top: 0;
  }

  &:hover,
  &.selecionado {
    background: #f0edf7;
  }
}

.trocar-conta-subconta__textos {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.trocar-conta-subconta__login {
  font-size: 0.86rem;
  font-weight: 600;
  color: #2b2640;
}

.trocar-conta-subconta__nome {
  font-size: 0.78rem;
}

.trocar-conta-ver-todas {
  display: inline-block;
  margin-top: 0.4rem;
  padding: 0.3rem 0;
  border: 0;
  background: none;
  color: $trocar-conta-purple;
  font-weight: 600;
  font-size: 0.82rem;

  &:hover {
    text-decoration: underline;
  }
}

.trocar-conta-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #d7deed;
  color: #3f4254;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1;
  padding: 0.25rem 0.5rem;
  text-transform: uppercase;
  white-space: nowrap;

  &--principal {
    background: #ece8f2;
    border-color: #d9cdf0;
    color: $trocar-conta-purple;
  }

  &--ativa {
    background: #edfdf8;
    border-color: #8de2c7;
    color: #0e8058;
  }

  &--inativa {
    background: #fff5f5;
    border-color: #f2b6bd;
    color: #b42335;
  }

  &--bloqueada {
    background: #fff8dd;
    border-color: #ffe7a3;
    color: #946200;
  }

  &--suspensa {
    background: #f8fafc;
    border-color: #d7deed;
    color: #7e8299;
  }
}
</style>
